import { apiRequest } from './apiClient';

/**
 * Ayarları listele
 */
export const fetchSettings = async ({ anahtar, aktif } = {}) => {
  const queryParams = {};
  if (anahtar) queryParams.anahtar = anahtar;
  if (aktif !== undefined) queryParams.aktif = aktif;

  const response = await apiRequest('/api/settings', {
    method: 'GET',
    query: queryParams,
  });

  return response;
};

/**
 * Tek bir ayarı getir
 */
export const fetchSetting = async (anahtar) => {
  const response = await apiRequest(`/api/settings/${anahtar}`, {
    method: 'GET',
  });

  return response;
};

/**
 * Panel ayarı (tüm giriş yapmış kullanıcılar, whitelist)
 */
export const fetchPanelSetting = async (anahtar) => {
  const response = await apiRequest(`/api/settings/panel/${encodeURIComponent(anahtar)}`, {
    method: 'GET',
  });

  return response;
};

/**
 * Ayar oluştur veya güncelle
 */
export const updateSetting = async (anahtar, data) => {
  const response = await apiRequest(`/api/settings/${anahtar}`, {
    method: 'PUT',
    body: data,
  });

  return response;
};

/**
 * Ayarı sil
 */
export const deleteSetting = async (anahtar) => {
  const response = await apiRequest(`/api/settings/${anahtar}`, {
    method: 'DELETE',
  });

  return response;
};

/**
 * Parça/işlem net fiyatlarını (fiyatgaranti) güncel iskonto oranına göre yeniden hesapla.
 */
export const recalcParcaFiyatlariFromIskonto = async () => {
  const response = await apiRequest('/api/settings/iskonto/parca-fiyatlarini-guncelle', {
    method: 'POST',
  });

  return response;
};
